import { Resource } from 'beisheim/models'

class Project extends Resource {
  static entity = 'Project'
  static baseEntity = 'Resource'

  get hasVideo () {
    const children = Resource.whereIdIn(this.children_ids).get()
    const hasVideo = children.find(c => c.columns.video)
    return hasVideo
  }
}

Resource.addModel(Project)

export { Project }
export default Project
